import api from "services/dashboard";

const state = {
  all: [],
  pagination: [],
  searchQuery: {
    schedule: null,
    appointment: null,
    financeSchedule: null,
    reminder: null,
    staffs: null,
    trainings: null,
    emnordv: null,
    scholar_year: null,
    interviewPeriod: null,
    contactpostem: null,
    acceptednotregistered: null,
    acceptedNotRegisteredFrom: null,
    scholarfeespending: null,
    scholarFeesPendingFrom: null
  },
  selectedFilters: {
    schedule: null,
    financeSchedule: null,
    reminder: null,
    staffs: null,
    trainings: null,
    emnordv: null,
    scholar_year: null,
    interviewPeriod: null,
    contactpostem: null,
    acceptednotregistered: null,
    acceptedNotRegisteredFrom: null,
    scholarfeespending: null,
    scholarFeesPendingFrom: null,
    training_paces: null,
    application_types: null
  },
  status: null
};

const getters = {
  getAllUsers: state => state.all,
  getAllUserCount: state => state.all.length,
  getSearchQuery: state => state.searchQuery,
  getSelectedFilters: state => state.selectedFilters,
  getStatus: state => state.status,
  totalPages(state) {
    return state.pagination.total_pages;
  },
  currentPage(state) {
    return state.pagination.current_page;
  },
  pagination(state) {
    return state.pagination;
  }
};

const mutations = {
  setUsers: (state, payload) => {
    state.all = payload.users;
    state.pagination = payload.meta.pagination;
    const { total, limit, skip } = state.pagination;
    state.totalPages = Math.ceil(total / limit);
    state.currentPage = Math.ceil((skip - 1) / limit) + 1;
  },
  resetSearch: state => {
    state.selectedFilters = {
      schedule: null,
      financeSchedule: null,
      reminder: null,
      staffs: null,
      trainings: null,
      emnordv: null,
      interviewPeriod: null,
      contactpostem: null,
      acceptednotregistered: null,
      acceptedNotRegisteredFrom: null,
      scholarfeespending: null,
      scholarFeesPendingFrom: null,
      training_paces: null,
      application_types: null
    };

    state.searchQuery = {
      schedule: null,
      financeSchedule: null,
      reminder: null,
      staffs: null,
      trainings: null,
      emnordv: null,
      interviewPeriod: null,
      contactpostem: null,
      acceptednotregistered: null,
      acceptedNotRegisteredFrom: null,
      scholarfeespending: null,
      scholarFeesPendingFrom: null,
      training_paces: null,
      application_types: null
    };
  },
  setStatus: (state, payload) => {
    state.status = payload.status;
  }
};

const actions = {
  async setUsers({ commit }, query) {
    const payload = await api.candidates(query);
    if ((await payload.status) === 200) {
      commit("setUsers", await payload.data);
    }
    commit("setStatus", await payload);
  },
  resetSearch({ commit }) {
    commit("resetSearch");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
